export default __webpack_public_path__ + "static/media/AnkleStiffness.4f389a8c.png";